import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import useMonarchStore from '@/stores/monarchStore';

interface ProtectedRouteProps {
  children: ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const isAuthenticated = useMonarchStore((s) => s.auth.isAuthenticated);

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
}
